import PubSub from 'pubsub-js'
import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

export const QuizNavigationWithTransition = ({ currentStep }) => {
  const context = useContext(QuizContext)
  const { displayLoader, displayStep } = context

  const questionAnswered = currentStep.values.every(value =>
    value.hasOwnProperty('value')
  )

  let { move } = context.actions

  const hasCustomSubmit =
    currentStep.id === 'loan_details' ||
    currentStep.id === 'object_address' ||
    currentStep.id === 'financial_details'

  const emitNextQuestionButtonClickedEvent = () => {
    PubSub.publish('NEXT_QUESTION_BUTTON_CLICKED')
  }

  const shouldDisplayNextButton =
    !displayLoader &&
    displayStep &&
    (!currentStep.mandatory || questionAnswered || hasCustomSubmit)

  return (
    <div className='[ f-wrap f-d-flr f-fl-al-ce f-fl-jc-sb f-fl-wrap f-t-centre f-t-left:m f-p-v-060 ] QuizApp-wrap QuizNavigation'>
      {shouldDisplayNextButton && (
        <CTA
          tag='button'
          type='block-primary'
          className='[ f-p-h-020 f-m-b-020 ] is-block:s'
          onClick={() =>
            hasCustomSubmit
              ? emitNextQuestionButtonClickedEvent()
              : move({ to: 'next' })
          }
          data-sel='btn-cta'
          wtData={{
            'CTA-click': {
              ...context.tracking.flow
            }
          }}>
          Nächste Frage
        </CTA>
      )}
      {context.data.stepIndex > 0 && (
        <CTA
          tag='button'
          type='text-primary'
          className='f-t-body f-m-b-020 QuizNavigation-back-button'
          onClick={() => move({ to: 'prev' })}
          data-sel='btn-back'
          wtData={{
            'CTA-click': {
              ...context.tracking.flow
            }
          }}>
          <Icon
            icon='left-link-16px'
            className='[ f-icon-020 f-icon-t-body f-c-st-inherit f-m-r-010 ]'
          />
          Vorherige Frage
        </CTA>
      )}
    </div>
  )
}

const QuizNavigation = ({ currentStep }) => {
  const context = useContext(QuizContext)
  const { displayLoader, displayStep } = context

  const questionAnswered = currentStep.values.every(value =>
    value.hasOwnProperty('value')
  )

  let { move } = context.actions

  const hasCustomSubmit =
    currentStep.id === 'loan_details' ||
    currentStep.id === 'object_address' ||
    currentStep.id === 'financial_details'

  const emitNextQuestionButtonClickedEvent = () => {
    PubSub.publish('NEXT_QUESTION_BUTTON_CLICKED')
  }

  const shouldDisplayNextButton =
    !displayLoader &&
    displayStep &&
    (!currentStep.mandatory || questionAnswered || hasCustomSubmit)

  return (
    <div className='[ f-wrap f-d-flr f-fl-al-ce f-fl-jc-sb f-fl-wrap f-t-centre f-t-left:m f-p-v-060 ] QuizApp-wrap QuizNavigation'>
      {shouldDisplayNextButton && (
        <CTA
          tag='button'
          type='block-primary'
          className='[ f-p-h-020 f-m-b-020 ] is-block:s'
          onClick={() =>
            hasCustomSubmit
              ? emitNextQuestionButtonClickedEvent()
              : move({ to: 'next' })
          }
          data-sel='btn-cta'
          wtData={{
            'CTA-click': {
              ...context.tracking.flow
            }
          }}>
          Nächste Frage
        </CTA>
      )}
      {context.data.stepIndex > 0 && (
        <CTA
          tag='button'
          type='text-primary'
          className='[ f-t-body f-m-b-020 f-fl-expand ]'
          onClick={() => move({ to: 'prev' })}
          data-sel='btn-back'
          wtData={{
            'CTA-click': {
              ...context.tracking.flow
            }
          }}>
          <Icon
            icon='left-link-16px'
            className='[ f-icon-020 f-icon-t-body f-c-st-inherit f-m-r-010 ]'
          />
          Vorherige Frage
        </CTA>
      )}
    </div>
  )
}

export default QuizNavigation
